// ArmazenaVariaveis.js

class Armazena {
    // Variáveis estáticas
    static dados = {};
    static dados2= {};
    // Método para atualizar os dados com o JSON da resposta do fetch
    static atualizarDados(objeto) {
      for (const chave in objeto) {
        if (objeto.hasOwnProperty(chave)) {
          this[chave] = objeto[chave];
        }
      }
      this.dados = objeto;
    }
    static atualizarDados2(objeto) {
      for (const chave in objeto) {
        if (objeto.hasOwnProperty(chave)) {
          this[chave] = objeto[chave];
        }
      }
      this.dados2 = objeto;
    }
   
  }
  
  export default Armazena;
  